import { gql } from "@apollo/client"

export const CHECK_AGREEMENT = gql`
  query checkAgreement($data: CheckAgreementRequest!) {
    agreements {
      checkAgreement(data: $data) {
        agreement {
          id
          document
          version
          content {
            text
            format
            title
            metadata
          }
        }
        isUserAgreedToTerms
        isUserEligible
        requiresAgreement
      }
    }
  }
`
